import {
    businessType,
    mleTurnOverCategory,
} from 'components/MerchantTab/constant';
import { ACCEPT_IMG_ONLY, ACCEPT_IMG_PDF, MAX_FILE_SIZE } from 'utils/constants/commonValues';
import { nameValueOptions } from 'utils/helperMethods';

export const MLE_CREATE_FORM_NAME = 'mleOnboardingForm';
export const MLE_ENTITY_TYPE = 'MLE';

export const actFields = {
    bankname: {
        name: 'bankName',
        label: 'Bank Name',
        type: 'text',
        required: true,
        fieldValidations: {
            required: true,
            alphaValid: true
        },
        place: 2,
    },
    ifscCode: {
        name: 'ifscCode',
        label: 'IFSC Code',
        type: 'text',
        fieldValidations: {
            required: true,
        }, 
        place: 3
    },
    accountNumber: {
        name: 'accountNumber',
        label: 'Account Number',
        type: 'select',
        fieldValidations: {
            required: true,
        },
        place: 1
    },
    accountHolderName: {
        name: 'accountHolderName',
        label: 'Account Holder Name',
        type: 'number',
        fieldValidations: {
            required: true,
            pinValid: true
        },
        disabled: true,
        place: 4,
  },
    
     mcc: {
        name: 'mcc',
        label: 'MCC',
        type: 'number',
        fieldValidations: {
            required: true,
        },
        place: 8,
    },
     businessCategory: {
        name: 'businessCategory',
        label: 'Merchant Category',
        type: 'text',
        fieldValidations: {
            required: true,
        },
        place: 6,
    },
     businessSubCategory: {
        name: 'businessSubCategory',
        label: 'Merchant Sub Category',
        type: 'text',
        fieldValidations: {
            required: true,
        },      
        place: 7,
    },
     merchantType: {
        name: 'merchantType',
        label: 'Merchant Type',
        type: 'text',
        fieldValidations: {
            required: true,
        },
        place: 9,
    },
    bankProofUrl:{
      name: 'bankProofUrl',
        label: 'Bank Proof',
        type: 'text',
        fieldValidations: {
            required: true,
        },
        place: 5,
    }
}

export const PREFIX_KYCURLS = 'kycDocUrls';
export const PIN_ERROR = 'Invalid pin';
export const BUSINESS_SECTION_TYPE_MLE = 'businessDetailSection';
export const MERCHANT_SECTION_TYPE_MLE = 'merchantDetailsSection';
export const BUSINESS_SECTION = 'businessDetails';
export const MAXIMUM_VALUE = 'maximum';
export const MINIMUM_VALUE = 'minimum';





// contants.js
export const getMleFields = (businessType, optionalFields = []) => {
    let isSoleProprietorship = businessType === 'MOB_SOLE_PROPRIETORSHIP';

    let shouldDisableCompanyIdValidations = 
      businessType === 'INDIVIDUAL' || 
      isSoleProprietorship;
    if (optionalFields?.length > 0) {
      isSoleProprietorship = false;
      shouldDisableCompanyIdValidations = false;
    }
    const baseFields = {
      legalName: {
        name: 'legalName',
        label: 'Merchant Legal Name',
        type: 'text',
        required: true,
        fieldValidations: {
          required: true,
          alphaValid: true
        },
        place: 1,
        infoMsgs: 'Please update new pan in case of legal name change'
      },
      brandName: {
        name: 'brandName',
        label: 'Brand Name',
        type: 'text',
        fieldValidations: {
          required: true,
        }, 
        place: 2
      },
      businessType: {
        name: 'businessType',
        label: 'Constitution Type',
        type: 'select',
        fieldValidations: {
          required: true,
        },
        place: 3
      },
      pin: {
        name: 'address.pinCode',
        label: 'PIN Code',
        type: 'number',
        fieldValidations: {
          required: true,
          pinValid: true
        },
        disabled: true,
        place: 4,
        infoMsgs: 'Please verify your address and update proof of address'
      },
      district: {
        name: 'address.district',
        label: 'District',
        type: 'select',
        disabled: true,
        fieldValidations: {
          required: true,
        },
        place: 5
      },
      state: {
        name: 'address.state',
        label: 'State',
        type: 'select',
        disabled: true,
        fieldValidations: {
          required: true,
        },
        place: 6
      },
      address: {
        name: 'address.addressLine',
        label: 'Address',
        type: 'text',
        required: true,
        fieldValidations: {
          required: true,
        },
        infoMsgs: "Please verify your pincode and update proof of address",
        place: 7
      },
      city: {
        name: 'address.city',
        label: 'City',
        type: 'select',
        disabled: true,
        fieldValidations: {
          required: true,
        },
        place: 8
      },
      panUpload: {
        name: 'panurl',
        reqname: 'panDetails.url',
        label: 'Company PAN Upload',
        type: 'file',
        required: true,
        maxFileSize: MAX_FILE_SIZE,
        accept: ACCEPT_IMG_PDF,
        fieldValidations: {
          required: true,
        },
        place: 9
    },
    pan: {
        name: 'panDetails.panNumber',
        label: 'Company PAN Number',
        type: 'text',
        disabled: true,
        fieldValidations: {
          required: true,
          panValid: true
        },
        place: 10
      },
      panName: {
        name: 'panDetails.name',
        label: 'Company PAN Name',
        type: 'text',
        required: true,
        fieldValidations: {
          required: true,
        },
        place: 11,
        infoMsgs: 'Please update legal name as PAN Name is updating'
    },
    panDate: {
        name: 'dateOfIncorporation',
        label: 'Date Of Incorporation / DOB',
        type: 'date',
        required: true,
        disabled: true,
        fieldValidations: {
          required: true,
        },
        place: 12
      },
      gstUpload: {
        name: 'gstUpload',
        reqName: 'gstUploadFile',
        label: 'GST Upload',
        type: 'file',
        required: !shouldDisableCompanyIdValidations,
        maxFileSize: MAX_FILE_SIZE,
        accept: ACCEPT_IMG_PDF,
        fieldValidations: {
          required: !shouldDisableCompanyIdValidations,
        },
        place: 13
      },
      gst: {
        name: 'gstNumber',
        label: 'GST Number',
        type: 'text',
        required: !shouldDisableCompanyIdValidations,
        fieldValidations: {
          required: !shouldDisableCompanyIdValidations,
          gstValid: !shouldDisableCompanyIdValidations
        },
        place: 14
      },
      turnOverCategory: {
        name: 'turnoverCategory',
        label: 'Turnover Category',
        type: 'select',
        data: nameValueOptions(mleTurnOverCategory) || [],
        required: false,
        fieldValidations: {
          required: true,
        },
        place: 15,
        infoMsgs: 'Please verify your turn over amount and update proof of business in KYC document section'
    },
    companyId: {
        name: 'companyIdentificationNumber',
        label: 'Company Identification Number',
        type: 'text',
        required: !shouldDisableCompanyIdValidations,
        fieldValidations: {
          required: !shouldDisableCompanyIdValidations,
          haveNumberValid: !shouldDisableCompanyIdValidations
        },
        place: 16
      },
      turnoverAmount: {
        name: 'turnoverAmount',
        label: 'Turnover Amount',
        type: 'number',
        required: false,
        fieldValidations: {
          required: true,
          rangeValid: true
        },
        place: 17
      },
      email: {
        name: 'emails',
        label: 'Email',
        type: 'text',
        required: true,
        fieldValidations: {
          required: true,
          emailValid: true
        },
        place: 18
      },
      websiteURLs: {
        name: 'websiteURLs',
        label: 'Website URL',
        type: 'text',
        required: !shouldDisableCompanyIdValidations,
        fieldValidations: {
          required: !shouldDisableCompanyIdValidations,
          urlValid: !shouldDisableCompanyIdValidations
        },
        place: 19
      },
      telephoneNumbers: {
        name: 'telephoneNumbers',
        label: 'Telephone Number',
        type: 'number',
        required: true,
        fieldValidations: {
          numericValid: true
        },
        place: 20
      },
      mobileNumber: {
        name: 'mobileNumbers',
        label: 'Mobile Number',
        type: 'number',
        required: true,
        fieldValidations: {
          required: true,
          mobileValid: true
        },
        place: 21
      },
      appLink: {
        name: 'appLink',
        label: 'App Link',
        type: 'text',
        required: !shouldDisableCompanyIdValidations,
        fieldValidations: {
          required: !shouldDisableCompanyIdValidations,
        },
        place: 22
      },
      verifyPan: {
        name: 'verify-pan',
        label: 'Verify PAN',
        buttonType: 'primary',
      },
      verifyGst: {
        name: 'verify-gst',
        label: 'Verify GST',
        buttonType: 'primary',
      },
       source: {
        name: 'source',
        label: 'Axis Sourced Merchant',
        type: 'checkbox', 
        place: 23,
        fieldValidations: {
          required: true,
        },
      },
    };

    if (optionalFields?.length > 0) {
      Object.entries(baseFields).forEach(([key, field]) => {
        if (optionalFields.includes(field.name) || 
            optionalFields.includes(field.reqname) || 
            optionalFields.includes(field.reqName)) {
          baseFields[key].fieldValidations.required = false;
        }
      });
    }
  
    return baseFields;
  };
  
  // Default export for backward compatibility
  export const mleFields = getMleFields();
  export const FORM_TOAST_MSGS = {
      POAREQUIRED: 'Please update at least one proof of address in the KYC document section.',
      POBREQUIRED: 'Please update at least one proof of business in the KYC document section.',
      POABREQUIRED: 'Please update at least one proof of address and one proof of  business in the KYC document section.',
      REQUIRED: 'Please fill all the required fields.',
      IMPROPERDATA: 'Please double check the data you have entered.',
  }
  export const ATLEAST_ONE = (category) =>  (`At least one ${category} document update is required.`);